// extracted by mini-css-extract-plugin
export var closeButton = "_mk-1";
export var closeX = "_mk-3";
export var container = "_mk-0";
export var image = "_mk-2";